module.exports = __webpack_public_path__ + "img/index-pic6.1f1e10ba.webp";